// Pre-generate a conversion lookup array.
const byteToHex: string[] = [];
for (let i = 0; i < 256; ++i) {
	byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

/**
 * Convert an array of 16 single-byte values to a UUID string.
 */
export function bytesToUuid(buf: Uint8Array, offset = 0): string {
	let i = offset;
	const bth = byteToHex;
	return (
		bth[buf[i++]] +
		bth[buf[i++]] +
		bth[buf[i++]] +
		bth[buf[i++]] +
		'-' +
		bth[buf[i++]] +
		bth[buf[i++]] +
		'-' +
		bth[buf[i++]] +
		bth[buf[i++]] +
		'-' +
		bth[buf[i++]] +
		bth[buf[i++]] +
		'-' +
		bth[buf[i++]] +
		bth[buf[i++]] +
		bth[buf[i++]] +
		bth[buf[i++]] +
		bth[buf[i++]] +
		bth[buf[i++]]
	);
}

export default bytesToUuid;
